import { render, staticRenderFns } from "./OrderRecordList.vue?vue&type=template&id=d2c0c066&scoped=true&"
import script from "./OrderRecordList.vue?vue&type=script&lang=js&"
export * from "./OrderRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c0c066",
  null
  
)

export default component.exports